var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.858 27c.472 0 .854-.37.854-.841v-6.234c.28-.124 1.34-.527 2.994-.527 4.17 0 6.782 2.03 10.746 2.03 1.755 0 2.407-.191 3.265-.573.779-.348 1.283-.93 1.283-1.962V7.512c0-.606-.519-.953-1.171-.953-.551 0-1.586.47-3.524.47C17.34 7.03 14.739 5 10.562 5c-1.758 0-2.421.19-3.28.572C6.509 5.919 6 6.502 6 7.522V26.16c0 .46.396.841.858.841zm14.594-7.266c-3.751 0-6.407-2.03-10.746-2.03-1.236 0-2.364.146-2.994.404V7.58c.158-.37 1.092-.886 2.85-.886 3.964 0 6.61 2.03 10.743 2.03 1.228 0 2.241-.146 2.994-.36v10.485c-.155.37-1.092.886-2.847.886z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLight);
export default __webpack_public_path__ + "static/media/Flag-Light.897aa1148f263653600fcff0d3a2bf70.svg";
export { ForwardRef as ReactComponent };